import { InsuranceDataType } from '../Settings/types';
import { Button } from '../../../Button';
import { Box, Typography } from '@mui/material';
import { Card } from '@uplift/icons';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { ComponentProps, useState } from 'react';
import { useFetchImages } from '../Settings/helpers';
import { makeStyles } from 'tss-react/mui';

export type AdminInsuranceCardProps = {
  insuranceData: InsuranceDataType;
} & ComponentProps<typeof Box>;

export const AdminInsuranceCard: React.FC<AdminInsuranceCardProps> = ({ insuranceData, ...props }) => {
  const { classes } = useAdminInsuranceCardStyles();
  const { images } = useFetchImages(insuranceData?.insuranceCardFront ?? '', insuranceData?.insuranceCardBack ?? '', insuranceData?.isNonPartnerInsurance);
  const [ showCard, setShowCard ] = useState(false);

  return (
    <Box {...props}>
      <Button onClick={() => setShowCard(p => !p)} sx={{ textTransform: 'none', display: 'flex', alignItems: 'center', gap: 1, ml: -2 }}>
        <Card />
        <Box display="flex" alignItems="center">
          <Typography variant="body2" component="span" color="textPrimary">
            {showCard ? 'Hide Insurance Card' : 'Show Insurance Card'}
          </Typography>
          {showCard ? <ExpandLess /> : <ExpandMore />}
        </Box>
      </Button>
      {showCard && (
        <Box display="flex" alignItems="center" gap={2} mt={2}>
          <Box flex={1}>
            <img src={images[0]} alt="insurance card front" className={classes.image} />
          </Box>
          <Box flex={1}>
            <img src={images[1]} alt="insurance card back" className={classes.image} />
          </Box>
        </Box>
      )}
    </Box>
  );
};

const useAdminInsuranceCardStyles = makeStyles()({
  image: {
    width: '100%',
    height: 'auto',
    aspectRatio: '16/9',
    objectFit: 'contain',
  },
});